import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './VouchersAddForm.module.scss';

interface VouchersAddFormProps {
  onApplyVoucher: (voucherCode: string) => void;
}

const VouchersAddForm: React.FC<VouchersAddFormProps> = ({ onApplyVoucher }) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const { t } = useTranslation();

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  const applyVoucher = () => {
    onApplyVoucher(String(inputRef.current?.value));
    if (inputRef.current) {
      inputRef.current.value = '';
    }
  };

  return (
    <div className={styles.voucherAddForm}>
      <input ref={inputRef} placeholder={t('txt_enter_voucher_code')} />
      <button onClick={applyVoucher}>{t('txt_apply')}</button>
    </div>
  );
};

export default VouchersAddForm;
